<!-- 表示するべきBookGroupの一覧表示 -->
<template>
  <div v-if="isReadyToDraw" class="myticket-index">
    <div class="index">
      <!-- bookGroupsをfor文でループ表示 -->
      <div
        class="masterbook_division"
        v-for="data in dataList"
        :key="data.bookGroup.id"
      >
        <template v-if="data.isStampRally">
          <ItemIndexBookStampRally
            :bookGroup="data.bookGroup"
            :latestCountDownLimitOfBookGroup="
              data.latestCountDownLimitOfBookGroup
            "
            :isNotTargetVersion="isNotTargetVersion"
          />
        </template>
        <template v-else>
          <ItemIndexBookPassSheet
            :bookGroup="data.bookGroup"
            :latestCountDownLimitOfBookGroup="
              data.latestCountDownLimitOfBookGroup
            "
          />
        </template>
      </div>
      <ItemButton
        v-show="isExistMoreTickets"
        :isDisabled="isDisabled"
        :label="label"
        actionType="btn-primary"
        @clicked="getMoreMytickets"
      />
    </div>
  </div>
  <DialogGetMyticketsError ref="DialogGetMyticketsError" />
  <DialogStampRallyVersionWarning ref="DialogStampRallyVersionWarning" />
</template>

<script>
import { onMounted, computed, ref, watch, provide, watchEffect } from "vue";

import { useStore } from "vuex";

import bookGroupService from "@/services/bookGroup";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TheBookGroupsIndex",
  props: {
    // 過去チケットを取得するか否か
    isUsedStatus: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const DialogGetMyticketsError = ref(null);
    const DialogStampRallyVersionWarning = ref(null);

    provide("openDialogStampRallyVersionWarning", () => {
      DialogStampRallyVersionWarning.value.openDialog();
    });

    const label = ref("続きを表示");
    const dataList = ref([]);
    const bookGroups = computed(() => store.getters["ticketing/bookGroups"]);

    const isDisabled = ref(false);
    const isReadyToDraw = ref(false);
    const isExistMoreTickets = computed(() =>
      bookGroups.value.length > 0
        ? bookGroups.value[bookGroups.value.length - 1]["next_page"] === "exist"
        : false
    );

    const appVersion = computed(() => store.getters["common/appVersion"]);
    const device = computed(() => store.getters["common/device"]);
    const isNotTargetVersion = ref(false);

    // 次の画面でやると描画の挙動がよくないので、ここで情報を整理
    onMounted(() => {
      pushDataList();
      isReadyToDraw.value = true;
      nativeHandlerService.ncAppVersion();
    });

    watch(bookGroups, () => pushDataList());

    const pushDataList = () => {
      // 追加データ取得時にstore側でconcatをして配列を整形しているので、重複を防ぐためにdataListを空にする。
      dataList.value = [];
      bookGroups.value.forEach((bookGroup) => {
        const latestCountDownLimitOfBookGroup =
          bookGroupService.getLatestCountDownLimit(bookGroup.books[0]);

        const isStampRally =
          bookGroup._master_book?.content?.description_json?.MbDisplayType ===
          "StampRally";

        dataList.value.push({
          bookGroup: bookGroup,
          latestCountDownLimitOfBookGroup: latestCountDownLimitOfBookGroup,
          isStampRally,
        });
      });
    };

    // 追加のチケットデータを取得する。
    const getMoreMytickets = async () => {
      try {
        isDisabled.value = true;
        label.value = "読み込み中...";
        await API.getMytickets(props.isUsedStatus, true);
        label.value = "続きを表示";
        isDisabled.value = false;
      } catch (e) {
        // エラーのポップアップを表示する。
        label.value = "続きを表示";
        isDisabled.value = false;
        DialogGetMyticketsError.value.openDialog();
      }
    };

    // 対象のバージョンかどうか確認
    const checkVersion = () => {
      let bool = false;
      switch (device.value) {
        case "IOS":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.1");
          break;
        case "ANDROID":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.1");
          break;
        default:
          bool = false;
          break;
      }
      isNotTargetVersion.value = bool;
    };

    // x.x.x(string)のバージョンを、比較用の数値に変換する
    const convertVersionForCompare = (ver) => {
      const verNums = ver.split(".");
      return verNums[0] * 100 + verNums[1] * 10 + verNums[2];
    };

    watchEffect(() => {
      if (appVersion.value != null && appVersion.value != undefined) {
        checkVersion();
      }
    });

    return {
      DialogGetMyticketsError,
      DialogStampRallyVersionWarning,
      label,
      dataList,
      isDisabled,
      isReadyToDraw,
      isExistMoreTickets,
      getMoreMytickets,
      isNotTargetVersion,
    };
  },
};
</script>

<style scoped lang="scss">
.myticket-index {
  background: #f9f9f9;
  padding: 2vw 0;
}

.index {
  position: relative;
  clear: both;
  width: 96%;
  margin: auto;
}
.masterbook_division {
  border-bottom: 3px solid #f9f9f9;
  background: white;
  border: 1px solid #e0e0e0;
  margin-bottom: 2vw;
  border-radius: 5px;
}
</style>
